export const SiteSettingsEnum = {
  General: 'General',
  Locations: 'Locations',
  DockGroupsBusinessUnits: 'DockGroupsBusinessUnits',
  Carriers: 'Carriers',
  CustomLiveMessages: 'CustomLiveMessages',
  CapabilityFlags: 'CapabilityFlags',
};

export type SiteSettingsEnum =
  (typeof SiteSettingsEnum)[keyof typeof SiteSettingsEnum];
